{
  "HELP_CENTER": {
    "TITLE": "Hjälpcenter",
    "NEW_PAGE": {
      "DESCRIPTION": "Skapa självbetjäningsportaler för hjälpcenter till dina kunder. Hjälp dem att hitta svar snabbt, utan att vänta. Effektivisera ärenden, öka agenternas effektivitet och förbättra kundsupporten.",
      "CREATE_PORTAL_BUTTON": "Skapa portal"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Namnlös"
    },
    "HEADER": {
      "FILTER": "Filtrera efter",
      "SORT": "Sortera efter",
      "LOCALE": "Språk",
      "SETTINGS_BUTTON": "Inställningar",
      "NEW_BUTTON": "Ny artikel",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Publicerad",
        "DRAFT": "Draft",
        "ARCHIVED": "Arkiverad"
      },
      "TITLES": {
        "ALL_ARTICLES": "Alla artiklar",
        "MINE": "Mina artiklar",
        "DRAFT": "Draft-artiklar",
        "ARCHIVED": "Arkiverade artiklar"
      },
      "LOCALE_SELECT": {
        "TITLE": "Välj språk",
        "PLACEHOLDER": "Välj språk",
        "NO_RESULT": "Inget språk hittades",
        "SEARCH_PLACEHOLDER": "Sök språk"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Alla artiklar",
      "PUBLISH_BUTTON": "Publicera",
      "MOVE_TO_ARCHIVE_BUTTON": "Flytta till arkiv",
      "PREVIEW": "Förhandsgranska",
      "ADD_TRANSLATION": "Lägg till översättning",
      "OPEN_SIDEBAR": "Öppna sidopanel",
      "CLOSE_SIDEBAR": "Stäng sidopanel",
      "SAVING": "Sparar...",
      "SAVED": "Sparad"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Ladda upp bild",
        "UPLOADING": "Laddar upp...",
        "SUCCESS": "Bilden laddades upp",
        "ERROR": "Fel vid uppladdning av bild",
        "UN_AUTHORIZED_ERROR": "Du har inte behörighet att ladda upp bilder",
        "ERROR_FILE_SIZE": "Bildstorleken bör vara mindre än {size}MB",
        "ERROR_FILE_FORMAT": "Bildformatet bör vara jpg, jpeg eller png",
        "ERROR_FILE_DIMENSIONS": "Bildmåtten bör vara mindre än 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Infoga ankare",
        "TITLE": "Infoga ankare",
        "SUBMIT": "Infoga",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Artikelinställningar",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Kategori",
          "TITLE": "Välj kategori",
          "PLACEHOLDER": "Välj kategori",
          "NO_RESULT": "Ingen kategori hittades",
          "SEARCH_PLACEHOLDER": "Sök kategori"
        },
        "AUTHOR": {
          "LABEL": "Författare",
          "TITLE": "Välj författare",
          "PLACEHOLDER": "Välj författare",
          "NO_RESULT": "Inga författare hittades",
          "SEARCH_PLACEHOLDER": "Sök författare"
        },
        "META_TITLE": {
          "LABEL": "Metatitel",
          "PLACEHOLDER": "Lägg till en metatitel"
        },
        "META_DESCRIPTION": {
          "LABEL": "Metabeskrivning",
          "PLACEHOLDER": "Lägg till din metabeskrivning för bättre SEO-resultat..."
        },
        "META_TAGS": {
          "LABEL": "Metataggar",
          "PLACEHOLDER": "Lägg till metataggar separerade med kommatecken..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Arkivera artikel",
        "DELETE": "Ta bort artikel"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Okategoriserad",
      "SEARCH_RESULTS": "Sökresultat för {query}",
      "EMPTY_TEXT": "Sök efter artiklar att infoga i svar.",
      "SEARCH_LOADER": "Söker...",
      "INSERT_ARTICLE": "Infoga",
      "NO_RESULT": "Inga artiklar hittades",
      "COPY_LINK": "Kopiera artikellänk till urklipp",
      "OPEN_LINK": "Öppna artikeln i en ny flik",
      "PREVIEW_LINK": "Förhandsgranska artikel"
    },
    "PORTAL": {
      "HEADER": "Portaler",
      "DEFAULT": "Standard",
      "NEW_BUTTON": "Ny portal",
      "ACTIVE_BADGE": "aktiv",
      "CHOOSE_LOCALE_LABEL": "Välj ett språk",
      "LOADING_MESSAGE": "Laddar portaler...",
      "ARTICLES_LABEL": "artiklar",
      "NO_PORTALS_MESSAGE": "Det finns inga tillgängliga portaler",
      "ADD_NEW_LOCALE": "Lägg till ett nytt språk",
      "POPOVER": {
        "TITLE": "Portaler",
        "PORTAL_SETTINGS": "Portalinställningar",
        "SUBTITLE": "Du har flera portaler och kan ha olika språk för varje portal.",
        "CANCEL_BUTTON_LABEL": "Avbryt",
        "CHOOSE_LOCALE_BUTTON": "Välj språk"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "artiklar",
            "ADD": "Lägg till språk",
            "VISIT": "Besök webbplats",
            "SETTINGS": "Inställningar",
            "DELETE": "Radera"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Portalkonfigurationer",
            "ITEMS": {
              "NAME": "Namn",
              "DOMAIN": "Anpassad domän",
              "SLUG": "Slug",
              "TITLE": "Portaltitel",
              "THEME": "Temafärg",
              "SUB_TEXT": "Portalens undertext"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Tillgängliga språk",
            "TABLE": {
              "NAME": "Språknamn",
              "CODE": "Språkkod",
              "ARTICLE_COUNT": "Antal artiklar",
              "CATEGORIES": "Antal kategorier",
              "SWAP": "Byt",
              "DELETE": "Radera",
              "DEFAULT_LOCALE": "Standard"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Ta bort portal",
          "MESSAGE": "Är du säker på att du vill ta bort den här portalen",
          "YES": "Ja, ta bort portal",
          "NO": "Nej, behåll portal",
          "API": {
            "DELETE_SUCCESS": "Portalen togs bort",
            "DELETE_ERROR": "Fel vid borttagning av portal"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Redigera portal",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Grundläggande information"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Portalanpassning"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Kategorier"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Språk"
          }
        },
        "CATEGORIES": {
          "TITLE": "Kategorier i",
          "NEW_CATEGORY": "Ny kategori",
          "TABLE": {
            "NAME": "Namn",
            "DESCRIPTION": "Beskrivning",
            "LOCALE": "Språk",
            "ARTICLE_COUNT": "Antal artiklar",
            "ACTION_BUTTON": {
              "EDIT": "Redigera kategori",
              "DELETE": "Ta bort kategori"
            },
            "EMPTY_TEXT": "Inga kategorier hittades"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Uppdatera grundinställningar"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Information om hjälpcenter",
            "BODY": "Grundläggande information om portalen"
          },
          "CUSTOMIZATION": {
            "TITLE": "Anpassning av hjälpcenter",
            "BODY": "Anpassa portal"
          },
          "FINISH": {
            "TITLE": "Klart! 🎉",
            "BODY": "Allt är klart!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Tillbaka",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Skapa portal",
            "TITLE": "Information om hjälpcenter",
            "CREATE_BASIC_SETTING_BUTTON": "Skapa grundinställningar för portal"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Portalanpassning",
            "TITLE": "Anpassning av hjälpcenter",
            "UPDATE_PORTAL_BUTTON": "Uppdatera portalinställningar"
          },
          "FINISH_PAGE": {
            "TITLE": "Klart! 🎉 Allt är klart!",
            "MESSAGE": "Du kan nu se den skapade portalen på sidan med alla portaler.",
            "FINISH": "Gå till sidan med alla portaler"
          }
        },
        "LOGO": {
          "LABEL": "Logotyp",
          "UPLOAD_BUTTON": "Ladda upp logotyp",
          "HELP_TEXT": "Den här logotypen visas i portalens rubrik.",
          "IMAGE_UPLOAD_SUCCESS": "Logotypen laddades upp",
          "IMAGE_UPLOAD_ERROR": "Logotypen togs bort",
          "IMAGE_DELETE_ERROR": "Fel vid borttagning av logotyp"
        },
        "NAME": {
          "LABEL": "Namn",
          "PLACEHOLDER": "Portalnamn",
          "HELP_TEXT": "Namnet används internt i den publika portalen.",
          "ERROR": "Namn krävs"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portal-slug för webbadresser",
          "ERROR": "Slug krävs"
        },
        "DOMAIN": {
          "LABEL": "Anpassad domän",
          "PLACEHOLDER": "Anpassad domän för portal",
          "HELP_TEXT": "Lägg endast till om du vill använda en anpassad domän för dina portaler. T.ex.: {exampleURL}",
          "ERROR": "Ange en giltig domän-URL"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Länk till startsida",
          "PLACEHOLDER": "Länk till portalens startsida",
          "HELP_TEXT": "Länken som används för att gå tillbaka från portalen till startsidan. T.ex.: {exampleURL}",
          "ERROR": "Ange en giltig URL för startsidan"
        },
        "THEME_COLOR": {
          "LABEL": "Portalens temafärg",
          "HELP_TEXT": "Den här färgen visas som temafärg för portalen."
        },
        "PAGE_TITLE": {
          "LABEL": "Sidtitel",
          "PLACEHOLDER": "Portalens sidtitel",
          "HELP_TEXT": "Sidtiteln används i den publika portalen.",
          "ERROR": "Sidtitel krävs"
        },
        "HEADER_TEXT": {
          "LABEL": "Rubriktext",
          "PLACEHOLDER": "Portalens rubriktext",
          "HELP_TEXT": "Portalens rubriktext används i den publika portalen.",
          "ERROR": "Portalens rubriktext krävs"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portalen skapades.",
          "ERROR_MESSAGE_FOR_BASIC": "Det gick inte att skapa portalen. Försök igen.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portalen uppdaterades.",
          "ERROR_MESSAGE_FOR_UPDATE": "Det gick inte att uppdatera portalen. Försök igen."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Lägg till ett nytt språk",
        "SUB_TITLE": "Detta lägger till ett nytt språk i din lista över tillgängliga översättningar.",
        "PORTAL": "Portal",
        "LOCALE": {
          "LABEL": "Språk",
          "PLACEHOLDER": "Välj ett språk",
          "ERROR": "Språk krävs"
        },
        "BUTTONS": {
          "CREATE": "Skapa språk",
          "CANCEL": "Avbryt"
        },
        "API": {
          "SUCCESS_MESSAGE": "Språket har lagts till",
          "ERROR_MESSAGE": "Det gick inte att lägga till språket. Försök igen."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Standardspråket har uppdaterats",
          "ERROR_MESSAGE": "Det gick inte att uppdatera standardspråket. Försök igen."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Språket togs bort från portalen",
          "ERROR_MESSAGE": "Det gick inte att ta bort språket från portalen. Försök igen."
        }
      }
    },
    "TABLE": {
      "404": "Inga artiklar matchar din sökning 🔍",
      "LOADING_MESSAGE": "Laddar artiklar...",
      "NO_ARTICLES": "Det finns inga tillgängliga artiklar",
      "HEADERS": {
        "TITLE": "Titel",
        "CATEGORY": "Kategori",
        "READ_COUNT": "Visningar",
        "STATUS": "Status",
        "LAST_EDITED": "Senast redigerad"
      },
      "COLUMNS": {
        "BY": "av",
        "AUTHOR_NOT_AVAILABLE": "Författaren är inte tillgänglig"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Laddar artikel...",
      "TITLE_PLACEHOLDER": "Artikelns titel skrivs här",
      "CONTENT_PLACEHOLDER": "Skriv din artikel här",
      "API": {
        "ERROR": "Fel vid sparande av artikel"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Fel vid publicering av artikel",
        "SUCCESS": "Artikeln publicerades"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Fel vid arkivering av artikel",
        "SUCCESS": "Artikeln arkiverades"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Fel vid sparande av artikel som Draft",
        "SUCCESS": "Artikeln sparades som Draft"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Bekräfta borttagning",
          "MESSAGE": "Är du säker på att du vill ta bort artikeln?",
          "YES": "Ja, ta bort",
          "NO": "Nej, behåll"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Artikeln togs bort",
        "ERROR_MESSAGE": "Fel vid borttagning av artikel"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Lägg till artikelns rubrik och innehåll innan du kan uppdatera inställningarna"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Sök efter artiklar"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Skapa en kategori",
        "SUB_TITLE": "Kategorin används i den publika portalen för att kategorisera artiklar.",
        "PORTAL": "Portal",
        "LOCALE": "Språk",
        "NAME": {
          "LABEL": "Namn",
          "PLACEHOLDER": "Kategorinamn",
          "HELP_TEXT": "Kategorinamnet och ikonen kommer att användas i den publika portalen för att kategorisera artiklar.",
          "ERROR": "Namn krävs"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Kategori-slug för webbadresser",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug krävs"
        },
        "DESCRIPTION": {
          "LABEL": "Beskrivning",
          "PLACEHOLDER": "Ge en kort beskrivning av kategorin.",
          "ERROR": "Beskrivning krävs"
        },
        "BUTTONS": {
          "CREATE": "Skapa kategori",
          "CANCEL": "Avbryt"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategorin skapades",
          "ERROR_MESSAGE": "Det gick inte att skapa kategorin"
        }
      },
      "EDIT": {
        "TITLE": "Redigera en kategori",
        "SUB_TITLE": "Om du redigerar en kategori uppdateras kategorin i den publika portalen.",
        "PORTAL": "Portal",
        "LOCALE": "Språk",
        "NAME": {
          "LABEL": "Namn",
          "PLACEHOLDER": "Kategorinamn",
          "HELP_TEXT": "Kategorinamnet och ikonen kommer att användas i den publika portalen för att kategorisera artiklar.",
          "ERROR": "Namn krävs"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Kategori-slug för webbadresser",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug krävs"
        },
        "DESCRIPTION": {
          "LABEL": "Beskrivning",
          "PLACEHOLDER": "Ge en kort beskrivning av kategorin.",
          "ERROR": "Beskrivning krävs"
        },
        "BUTTONS": {
          "CREATE": "Uppdatera kategori",
          "CANCEL": "Avbryt"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategorin uppdaterades",
          "ERROR_MESSAGE": "Det gick inte att uppdatera kategorin"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Kategorin togs bort",
          "ERROR_MESSAGE": "Det gick inte att ta bort kategorin"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Sök artiklar",
      "PLACEHOLDER": "Sök artiklar",
      "NO_RESULT": "Inga artiklar hittades",
      "SEARCHING": "Söker...",
      "SEARCH_BUTTON": "Sök",
      "INSERT_ARTICLE": "Infoga länk",
      "IFRAME_ERROR": "URL:en är tom eller ogiltig. Innehållet kan inte visas.",
      "OPEN_ARTICLE_SEARCH": "Infoga artikel från hjälpcenter",
      "SUCCESS_ARTICLE_INSERTED": "Artikeln infogades",
      "PREVIEW_LINK": "Förhandsgranska artikel",
      "CANCEL": "Stäng",
      "BACK": "Tillbaka",
      "BACK_RESULTS": "Tillbaka till resultat"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Hjälpcenter",
      "DESCRIPTION": "Skapa användarvänliga självbetjäningsportaler. Hjälp dina användare att komma åt artiklarna och få support dygnet runt. Uppgradera din prenumeration för att aktivera den här funktionen.",
      "SELF_HOSTED_DESCRIPTION": "Skapa användarvänliga självbetjäningsportaler. Hjälp dina användare att komma åt artiklarna och få support dygnet runt. Kontakta din administratör för att aktivera den här funktionen.",
      "BUTTON": {
        "LEARN_MORE": "Läs mer",
        "UPGRADE": "Uppgradera"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Flera portaler",
          "DESCRIPTION": "Skapa flera hjälpcenterportaler för olika produkter med samma konto."
        },
        "LOCALES": {
          "TITLE": "Fullt stöd för språk",
          "DESCRIPTION": "Lokalisera portalen till ditt språk. Vi stöder alla språk och tillåter översättningar för varje artikel."
        },
        "SEO": {
          "TITLE": "SEO-vänlig design",
          "DESCRIPTION": "Anpassa dina metataggar för att förbättra din synlighet i sökmotorer med våra SEO-vänliga sidor."
        },
        "API": {
          "TITLE": "Fullt API-stöd",
          "DESCRIPTION": "Använd portalen som ett headless CMS med tredjeparts frontend-ramverk via våra API:er."
        }
      }
    },
    "LOADING": "Laddar...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} visning | {count} visningar",
          "DROPDOWN_MENU": {
            "PUBLISH": "Publicera",
            "DRAFT": "Draft",
            "ARCHIVE": "Arkivera",
            "DELETE": "Radera"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Publicerad",
            "ARCHIVED": "Arkiverad"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Okategoriserad"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Alla artiklar",
          "MINE": "Mina",
          "DRAFT": "Draft",
          "PUBLISHED": "Publicerad",
          "ARCHIVED": "Arkiverad"
        },
        "CATEGORY": {
          "ALL": "Alla kategorier"
        },
        "LOCALE": {
          "ALL": "Alla språk"
        },
        "NEW_ARTICLE": "Ny artikel"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Skriv en artikel",
          "SUBTITLE": "Skriv en innehållsrik artikel, nu kör vi!",
          "BUTTON_LABEL": "Ny artikel"
        },
        "MINE": {
          "TITLE": "Du har inte skrivit några artiklar här",
          "SUBTITLE": "Alla artiklar som du har skrivit visas här för snabb åtkomst."
        },
        "DRAFT": {
          "TITLE": "Det finns inga artiklar i Draft",
          "SUBTITLE": "Draft-artiklar visas här"
        },
        "PUBLISHED": {
          "TITLE": "Det finns inga publicerade artiklar",
          "SUBTITLE": "Publicerade artiklar visas här"
        },
        "ARCHIVED": {
          "TITLE": "Det finns inga artiklar i arkivet",
          "SUBTITLE": "Arkiverade artiklar visas inte i portalen. Du kan använda arkivet för att markera föråldrade eller inaktuella sidor"
        },
        "CATEGORY": {
          "TITLE": "Det finns inga artiklar i den här kategorin",
          "SUBTITLE": "Artiklar i den här kategorin visas här"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Ny kategori",
        "EDIT_CATEGORY": "Redigera kategori",
        "CATEGORIES_COUNT": "{n} kategori | {n} kategorier",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Kategorier ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} artiklar) | {categoryName} ({categoryCount} artikel)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Inga kategorier hittades",
        "SUBTITLE": "Kategorier visas här. Du kan lägga till en kategori genom att klicka på knappen \"Ny kategori\"."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} artikel | {count} artiklar",
        "EXPAND": "Visa underkategorier",
        "COLLAPSE": "Dölj underkategorier",
        "MENU": {
          "NEW_ARTICLE": "Ny artikel",
          "ADD_SUBCATEGORY": "Lägg till underkategori",
          "EDIT": "Redigera",
          "DELETE": "Radera"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorin skapades",
            "ERROR_MESSAGE": "Det gick inte att skapa kategorin"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorin uppdaterades",
            "ERROR_MESSAGE": "Det gick inte att uppdatera kategorin"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorin togs bort",
            "ERROR_MESSAGE": "Det gick inte att ta bort kategorin"
          },
          "CONFIRM": {
            "TITLE": "Ta bort kategori",
            "DESCRIPTION": "Är du säker på att du vill ta bort den här kategorin? Dess artiklar blir okategoriserade.",
            "DESCRIPTION_WITH_CHILDREN": "Är du säker på att du vill ta bort den här kategorin? Dess artiklar blir okategoriserade och dess {count} underkategori flyttas till toppnivån. | Är du säker på att du vill ta bort den här kategorin? Dess artiklar blir okategoriserade och dess {count} underkategorier flyttas till toppnivån.",
            "CONFIRM": "Ta bort"
          }
        },
        "HEADER": {
          "CREATE": "Skapa kategori",
          "EDIT": "Redigera kategori",
          "DESCRIPTION": "Om du redigerar en kategori uppdateras kategorin i den publika portalen.",
          "PORTAL": "Portal",
          "LOCALE": "Språk"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Namn",
            "PLACEHOLDER": "Kategorinamn",
            "ERROR": "Namn krävs"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Kategori-slug för webbadresser",
            "ERROR": "Slug krävs",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Beskrivning",
            "PLACEHOLDER": "Ge en kort beskrivning av kategorin.",
            "ERROR": "Beskrivning krävs"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Överordnad kategori",
            "PLACEHOLDER": "Välj en överordnad kategori",
            "NONE": "Ingen (toppnivå)"
          }
        },
        "BUTTONS": {
          "CREATE": "Skapa",
          "EDIT": "Uppdatera",
          "CANCEL": "Avbryt"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Inga språk tillgängliga | {n} språk | {n} språk",
      "NEW_LOCALE_BUTTON_TEXT": "Nytt språk",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} artikel | {count} artiklar",
        "CATEGORIES_COUNT": "{count} kategori | {count} kategorier",
        "DEFAULT": "Standard",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Ange som standard",
          "DELETE": "Radera"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Lägg till ett nytt språk",
        "DESCRIPTION": "Välj det språk som den här artikeln ska skrivas på. Det läggs till i din lista över översättningar, och du kan lägga till fler senare.",
        "COMBOBOX": {
          "PLACEHOLDER": "Välj språk..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Språket har lagts till",
          "ERROR_MESSAGE": "Det gick inte att lägga till språket. Försök igen."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Sparar...",
          "SAVED": "Sparad"
        },
        "PREVIEW": "Förhandsgranska",
        "PUBLISH": "Publicera",
        "DRAFT": "Draft",
        "ARCHIVE": "Arkivera",
        "BACK_TO_ARTICLES": "Tillbaka till artiklar"
      },
      "DRAFT": {
        "PENDING_LABEL": "Opublicerade ändringar",
        "PROMOTE": "Publicera ändringar",
        "DISCARD": "Ta bort ändringar",
        "PROMOTE_SUCCESS": "Draft-ändringarna har publicerats till den aktiva artikeln",
        "PROMOTE_ERROR": "Det gick inte att publicera Draft-ändringarna",
        "DISCARD_SUCCESS": "Draft-ändringarna har tagits bort",
        "DISCARD_ERROR": "Det gick inte att ta bort Draft-ändringarna"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Versionshistorik",
        "TITLE": "Versionshistorik",
        "BACK": "Tillbaka till artikeln",
        "LOADING": "Laddar versioner...",
        "EMPTY": "Inga versioner än. Ändringar i den här artikeln visas här.",
        "EMPTY_CONTENT": "Den här versionen har inget innehåll.",
        "CURRENT_BADGE": "Aktuell",
        "RESTORED_BADGE": "Återställd",
        "AUTOMATED_USER": "Automatisk uppdatering",
        "RESTORE": "Återställ den här versionen",
        "RESTORE_DIALOG": {
          "TITLE": "Återställa den här versionen?",
          "DESCRIPTION": "Artikeln återgår till texten i den här versionen. Inget försvinner — den aktuella texten finns kvar i historiken, och en publicerad artikel fortsätter visa den publicerade versionen tills du publicerar ändringen.",
          "CONFIRM": "Återställ"
        },
        "RESTORE_SUCCESS": "Versionen har återställts",
        "RESTORE_ERROR": "Det gick inte att återställa den här versionen",
        "FETCH_ERROR": "Det gick inte att läsa in versionshistoriken"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Fler egenskaper",
        "TRANSLATE": "Översätt",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Okategoriserade",
        "EDITOR_PLACEHOLDER": "Skriv något...",
        "HTML_EMBED": {
          "TITLE": "Infoga anpassad HTML",
          "DESCRIPTION": "Klistra in rå HTML som en iframe, en inbäddning eller ett widget-utdrag. Det visas som det är i den publicerade artikeln.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Infoga"
        },
        "PRIMARY_CATEGORY": "Huvudkategori"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Artikelegenskaper",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "Metabeskrivning",
        "META_DESCRIPTION_PLACEHOLDER": "Lägg till metabeskrivning",
        "META_TITLE": "Metatitel",
        "META_TITLE_PLACEHOLDER": "Lägg till metatitel",
        "META_TAGS": "Metataggar",
        "META_TAGS_PLACEHOLDER": "Lägg till metataggar",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Språkversioner",
        "LANGUAGE_MUTATIONS_EMPTY": "Inga länkade artiklar än",
        "ADD_MUTATION": "Lägg till",
        "REMOVE_MUTATION": "Ta bort"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Länka språkversioner",
        "SEARCH_PLACEHOLDER": "Sök artiklar efter titel",
        "EMPTY": "Inga matchande artiklar",
        "CANCEL": "Avbryt",
        "ADD_SELECTED": "Lägg till valda",
        "SUCCESS": "Versioner uppdaterade",
        "ERROR": "Kunde inte uppdatera versioner"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Översätt artikel",
        "DESCRIPTION": "Välj de språk som du vill översätta den här artikeln till. Språk som redan har översatts kommer att översättas igen till ett Draft för granskning.",
        "EMPTY": "Inga andra språk är tillgängliga",
        "CONNECTED_BADGE": "Översatt",
        "CANCEL": "Avbryt",
        "TRANSLATE": "Översätt",
        "SUCCESS": "Översättningen börjar snart. De översatta artiklarna visas snart som språkversioner.",
        "ERROR": "Det gick inte att starta översättningen"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "Fel vid sparande av artikel"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Ny portal",
      "PORTALS": "Portaler",
      "CREATE_PORTAL": "Skapa och hantera flera portaler",
      "ARTICLES": "artiklar",
      "DOMAIN": "domän",
      "PORTAL_NAME": "Portalnamn"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Skapa ny portal",
      "DESCRIPTION": "Ge din portal ett namn och skapa en användarvänlig URL-slug. Du kan ändra båda senare i inställningarna.",
      "CONFIRM_BUTTON_LABEL": "Skapa",
      "NAME": {
        "LABEL": "Namn",
        "PLACEHOLDER": "Användarguide",
        "MESSAGE": "Välj ett namn för din portal.",
        "ERROR": "Namn krävs"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Slug krävs",
        "FORMAT_ERROR": "Använd bara bokstäver, siffror och bindestreck, till exempel: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logotyp",
          "IMAGE_UPLOAD_ERROR": "Det gick inte att ladda upp bilden! Försök igen",
          "IMAGE_UPLOAD_SUCCESS": "Bilden lades till. Klicka på Spara ändringar för att spara logotypen",
          "IMAGE_DELETE_SUCCESS": "Logotypen togs bort",
          "IMAGE_DELETE_ERROR": "Det gick inte att ta bort logotypen",
          "IMAGE_UPLOAD_SIZE_ERROR": "Bildstorleken bör vara mindre än {size}MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "Namn",
          "PLACEHOLDER": "Portalnamn",
          "ERROR": "Namn krävs"
        },
        "HEADER_TEXT": {
          "LABEL": "Rubriktext",
          "PLACEHOLDER": "Portalens rubriktext"
        },
        "PAGE_TITLE": {
          "LABEL": "Sidtitel",
          "PLACEHOLDER": "Portalens sidtitel"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Länk till startsida",
          "PLACEHOLDER": "Länk till portalens startsida",
          "ERROR": "Ogiltig URL. Länken till startsidan måste börja med \"http://\" eller \"https://\"."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portal-slug"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Live chat-widget",
          "PLACEHOLDER": "Välj live chat-widget",
          "HELP_TEXT": "Välj en live chat-widget som visas i ditt hjälpcenter"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Offentligt tillgänglig",
          "HELP_TEXT": "Gör portalen tillgänglig för alla med länken.",
          "OPTIONS": {
            "PUBLIC": "Ja",
            "PRIVATE": "Nej"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Länkmål",
          "HELP_TEXT": "Välj om länkar i artiklar öppnas i det aktuella fönstret eller i ett nytt.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Aktuellt fönster",
            "NEW_WINDOW": "Nytt fönster"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Standardstorlek för bilder",
          "HELP_TEXT": "Storleken som används för varje bild du infogar i en artikel. Välj Original för att infoga bilder i sin ursprungliga storlek, eller välj en storlek för varje bild istället."
        },
        "BRAND_COLOR": {
          "LABEL": "Varumärkesfärg"
        },
        "CUSTOM_HTML": {
          "LABEL": "Anpassad HTML",
          "PLACEHOLDER": "<!-- Klistra in din analys- eller spårningskod här -->",
          "HELP_TEXT": "Infogas i början av <body>-taggen på varje sida i ditt hjälpcenter. Använd den för Google Analytics, Google Tag Manager eller andra spårningsskript. Koden visas exakt som den har angetts och valideras inte."
        },
        "SAVE_CHANGES": "Spara ändringar"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Anpassad domän",
          "LABEL": "Anpassad domän:",
          "DESCRIPTION": "Du kan hosta din portal på en anpassad domän. Om din webbplats till exempel är yourdomain.com och du vill att din portal ska vara tillgänglig på docs.yourdomain.com, anger du bara det i det här fältet.",
          "PLACEHOLDER": "Anpassad domän för portal",
          "EDIT_BUTTON": "Redigera anpassad domän",
          "ADD_BUTTON": "Lägg till anpassad domän",
          "DIALOG": {
            "ADD_HEADER": "Lägg till anpassad domän",
            "EDIT_HEADER": "Redigera anpassad domän",
            "ADD_CONFIRM_BUTTON_LABEL": "Lägg till domän",
            "EDIT_CONFIRM_BUTTON_LABEL": "Uppdatera domän",
            "LABEL": "Anpassad domän",
            "PLACEHOLDER": "Anpassad domän för portal",
            "ERROR": "Anpassad domän krävs"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "DNS-konfiguration",
            "DESCRIPTION": "Logga in på kontot du har hos din DNS-leverantör och lägg till CNAME-posten nedan för din subdomän.",
            "HELP_TEXT": "När det är klart kan du kontakta vår support för att begära det automatiskt genererade SSL-certifikatet.",
            "CONFIRM_BUTTON_LABEL": "Uppfattat!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Ta bort {portalName}",
          "HEADER": "Ta bort portal",
          "DESCRIPTION": "Ta bort den här portalen permanent. Åtgärden kan inte ångras",
          "DIALOG": {
            "HEADER": "Är du säker på att du vill ta bort {portalName}?",
            "DESCRIPTION": "Detta är en permanent åtgärd som inte kan ångras.",
            "CONFIRM_BUTTON_LABEL": "Radera"
          }
        },
        "EDIT_CONFIGURATION": "Redigera konfiguration"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portalen skapades",
          "ERROR_MESSAGE": "Det gick inte att skapa portalen"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portalen uppdaterades",
          "ERROR_MESSAGE": "Det gick inte att uppdatera portalen"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Bilagor",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "Lägg till fil",
      "DROP_HERE": "Dra och släpp filer här",
      "COPY_LINK": "Kopiera länk",
      "LINK_COPIED": "Länken kopierades till urklipp",
      "COPY_FAILED": "Det gick inte att kopiera länken",
      "DELETE": "Radera",
      "CANCEL": "Avbryt",
      "QUEUED": "I kö",
      "UPLOADING": "Laddar upp",
      "UPLOAD_FAILED": "Det gick inte att ladda upp filen",
      "FILE_TOO_LARGE": "Filen överskrider gränsen på 40 MB"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Översättningsordlista",
        "DESCRIPTION": "Termer som definieras här läggs till i AI-översättningsprompten så att de alltid översätts på samma sätt. Nyckeltermen är skriven på {locale}."
      },
      "NEW_TERM": "Ny term",
      "EMPTY_STATE": {
        "TITLE": "Inga termer i ordlistan än",
        "SUBTITLE": "Lägg till en term och dess översättning för varje språk. När en artikel översätts tillämpas dessa termer så att din produkts terminologi förblir konsekvent."
      },
      "LIST": {
        "TERM": "Term",
        "TRANSLATIONS": "Översättningar",
        "ACTIONS": "Åtgärder"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Lägg till term",
          "EDIT": "Redigera term",
          "DESCRIPTION": "Termen nedan tillämpas vid AI-översättning av dina hjälpcenterartiklar.",
          "PORTAL": "Portal",
          "PRIMARY_LANGUAGE": "Primärt språk"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Term ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "Term krävs"
          },
          "DESCRIPTION": {
            "LABEL": "Kontext/anteckningar (valfritt)",
            "PLACEHOLDER": "När och hur den här termen används, för att hjälpa översättaren att förtydliga betydelsen."
          },
          "TRANSLATIONS": "Översättningar",
          "TRANSLATION_PLACEHOLDER": "Lämna tomt för att låta AI:n översätta fritt",
          "AUTO_TRANSLATE": {
            "BUTTON": "Auto-översätt alla",
            "CONFIRM": "Översätt till {count} språk med AI?",
            "CONFIRM_BUTTON": "Översätt",
            "CANCEL": "Avbryt",
            "SUCCESS": "Översättningar genererade — granska och spara",
            "ERROR": "Det gick inte att auto-översätta. Försök igen."
          }
        },
        "BUTTONS": {
          "CREATE": "Lägg till term",
          "EDIT": "Spara",
          "CANCEL": "Avbryt"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Termen lades till",
            "ERROR_MESSAGE": "Det gick inte att lägga till termen. Försök igen."
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Termen uppdaterades",
            "ERROR_MESSAGE": "Det gick inte att uppdatera termen. Försök igen."
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Ta bort term",
          "DESCRIPTION": "Är du säker på att du vill ta bort den här termen? Den kommer inte längre att tillämpas vid översättning.",
          "CONFIRM": "Ta bort"
        },
        "API": {
          "SUCCESS_MESSAGE": "Termen togs bort",
          "ERROR_MESSAGE": "Det gick inte att ta bort termen. Försök igen."
        }
      }
    }
  }
}
